import { render } from "./404.vue?vue&type=template&id=6191fc4a&scoped=true"
const script = {}

import "./404.vue?vue&type=style&index=0&id=6191fc4a&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6191fc4a"]])

export default __exports__